import React from 'react';
import cx from 'classnames';

import styles from '~/components/inputs/toggle-switch.module.scss';

const ToggleSwitch = ({ checked, handleChange, ariaLabel }) => {
  return (
    <label className={styles.toggleSwitch} aria-label={ariaLabel}>
      <input type="checkbox" checked={checked} onChange={handleChange} />
      <span className={styles.slider} />
      <span className={cx(styles.iconWrapper, styles.iconLeft)}>
        <img
          className={styles.checkMarkIcon}
          alt="checkmark"
          src="/icons/styled-white-check.svg"
          height="15"
          width="18"
        />
      </span>
      <span className={cx(styles.iconWrapper, styles.iconRight)}>
        <img
          className={styles.xIcon}
          alt="X"
          src="/icons/styled-white-x.svg"
          height="15"
          width="15"
        />
      </span>
    </label>
  );
};

export default ToggleSwitch;
